import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
})
export class PermissionComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
